
import { Component, Vue } from 'vue-property-decorator';
import { NavigationGuardNext, Route } from 'vue-router';
import { AxiosError } from 'axios';
import PortalHeader from '@/components/Layout/PortalHeader.vue';
import { isJwtTokenValid } from '@/router/guards';
import { VerificationStatuses } from '@/interfaces/bank-account';

Component.registerHooks(['beforeRouteEnter']);

@Component({ components: { PortalHeader } })
export default class Portal extends Vue {
  loading = true;

  setLoading(val: boolean) {
    this.loading = val;
  }

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    if (!isJwtTokenValid()) {
      next({ name: 'login' });
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next(async (vm: any) => {
      if (!vm.hasBankDetails) {
        try {
          await vm.$store.dispatch('Account/getBankDetails');
        } catch (e) {
          const error = e as AxiosError;
          if (error.response?.status === 404) {
            if (to.name === 'bank-account-setup') {
              vm.setLoading(false);
              return;
            }

            vm.routeTo('bank-account-setup');
            vm.setLoading(false);
          } else {
            vm.routeTo('error');
          }
          return;
        }
      }

      if (vm.$store.getters['Account/getBankAccountStatus'] !== VerificationStatuses.VERIFIED) {
        if (to.name !== 'bank-account-setup') {
          vm.routeTo('bank-account-setup');
        }
        vm.setLoading(false);
        return;
      }

      // At this point we've determined that the account is verified
      // so we prevent them from accessing the setup again
      if (to.name === 'bank-account-setup') {
        vm.routeTo('home');
      }
      vm.setLoading(false);
    });
  }

  get hasBankDetails(): boolean {
    return this.$store.getters['Account/hasBankDetails'];
  }

  routeTo(name: string) {
    this.$router.push({ name });
  }
}
